/**
 * DailyKpisRow — Tages-KPIs im Dashboard-Tab „Auswertungen" (Jul-2026, User-Wunsch).
 * Verkäufe heute · offene Rechnungen · Werkstatt-Auslastung — mit Direkt-Sprung.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Car, FileText, Wrench, ChevronRight } from "lucide-react";
import api from "../../lib/api";

const eur = (v) => `${Number(v || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export default function DailyKpisRow() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/dealer/analytics/daily-kpis")
            .then(({ data }) => { if (alive) setData(data); })
            .catch(() => { if (alive) setData(null); });
        return () => { alive = false; };
    }, []);

    if (!data) return null;
    const tiles = [
        {
            key: "sales", icon: Car, label: "Verkäufe heute", to: "/dealer/analytics",
            value: data.sales_today?.count ?? 0,
            sub: eur(data.sales_today?.amount_gross),
        },
        {
            key: "invoices", icon: FileText, label: "Offene Rechnungen", to: "/dealer/invoices",
            value: data.invoices_open?.count ?? 0,
            sub: `${eur(data.invoices_open?.amount_open)}${data.invoices_open?.overdue ? ` · ${data.invoices_open.overdue} überfällig` : ""}`,
            urgent: (data.invoices_open?.overdue || 0) > 0,
        },
        {
            key: "workshop", icon: Wrench, label: "Werkstatt-Auslastung", to: "/dealer/workshop-orders?status=open",
            value: data.workshop_open?.count ?? 0,
            sub: "offene Aufträge",
        },
    ];
    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4" data-testid="daily-kpis-row">
            {tiles.map((t) => (
                <button key={t.key} type="button" onClick={() => navigate(t.to)}
                    className="group bg-white border border-gray-200 rounded-sm p-3 text-left hover:border-[#FFCC00] transition-colors"
                    data-testid={`daily-kpi-${t.key}`}>
                    <div className="flex items-center justify-between">
                        <span className="text-[11px] font-bold uppercase tracking-wider text-gray-500 flex items-center gap-1.5">
                            <t.icon className="w-3.5 h-3.5" /> {t.label}
                        </span>
                        <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-[#111827]" />
                    </div>
                    <div className={`font-display font-black text-2xl mt-1 font-mono-num ${t.urgent ? "text-red-600" : "text-[#111827]"}`}>{t.value}</div>
                    <div className="text-xs text-gray-500 truncate">{t.sub}</div>
                </button>
            ))}
        </div>
    );
}
